import img from '../../Assets/LearningPath/graphic-design.png'
const GraphicDesigningInput = [
    {
        key : 1,
        img : img,
        title : "Fundamentals Of GRaphic Design",
        btn : "Watch Videos",
    },
    {
        key : 2,
        img : img,
        title : "Advance Graphic Designing",
        btn : "Watch Videos",
    },
    {
        key : 3,
        img : img,
        title : "Advance Video Editing",
        btn : "Watch Videos",
    },
];
export default GraphicDesigningInput;